import { QUERY_PARAMETERS } from "@/constants";

export const INVOICE_PARAMS = new Set([
    QUERY_PARAMETERS.PAGE_NO,
    QUERY_PARAMETERS.START_TIME,
    QUERY_PARAMETERS.END_TIME,
    QUERY_PARAMETERS.SORT,
    QUERY_PARAMETERS.STATUS,
    QUERY_PARAMETERS.SEARCH,
    QUERY_PARAMETERS.CURRENCY
]);
export const ACTIVITY_LOG_PARAMS = new Set([
    QUERY_PARAMETERS.PAGE_NO,
    QUERY_PARAMETERS.START_TIME,
    QUERY_PARAMETERS.END_TIME,
    QUERY_PARAMETERS.SORT,
    QUERY_PARAMETERS.ENTITY,
    QUERY_PARAMETERS.SEARCH
]);
export const CUSTOMERS_PARAMS = new Set([
    QUERY_PARAMETERS.PAGE_NO,
    QUERY_PARAMETERS.SORT,
    QUERY_PARAMETERS.SEARCH
]);
export const ACCOUNT_TRANSACTIONS_PARAMS = new Set([
    QUERY_PARAMETERS.PAGE_NO,
    QUERY_PARAMETERS.START_TIME,
    QUERY_PARAMETERS.END_TIME,
    QUERY_PARAMETERS.SORT,
    QUERY_PARAMETERS.TRANSACTION_TYPE,
    QUERY_PARAMETERS.SEARCH
]);